import {User} from "../common/user";

User.$inject = [
  "security.sessionStore",
];

export default User;
